<!--
 * @Description: 缓存管理页面
 * @Author: laoliu
 * @Date: 2022-08-6 11:43:52
-->
<template>
  <sys-cache-mng />
</template>

<script>
export default {
    mounted() {
        this.$emit("breadcrumb", {text1: '系统管理', text2: '缓存管理'});
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sysmng/CacheMng.vue